import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "./components/HeroSection";
import TopicIndexSection from "./components/TopicIndexSection";
import FeaturedFlowSection from "./components/FeaturedFlowSection";
import IndustryChainSection from "./components/IndustryChainSection";
import AlertSection from "./components/AlertSection";
import EvidenceSection from "./components/EvidenceSection";
import LeakDeskSection from "./components/LeakDeskSection";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <TopicIndexSection />
        <FeaturedFlowSection />
        <IndustryChainSection />
        <AlertSection />
        <EvidenceSection />
        <LeakDeskSection />
      </main>
      <SiteFooter />
    </div>
  );
}